import { getInitialDataImplementation } from "@/api/Implementation/initialLoad";
import { useQuery } from "react-query";

const key = "initial_data_implementation";

export function useInitialDataImplementation(params) {
	return useQuery([key], () => getInitialDataImplementation(params), {
		staleTime: Infinity,
		cacheTime: Infinity,
	});
}
